import { Observable } from "rxjs";
import { DataService } from "@bb-vendure/admin-ui/core";
import { Pipe, PipeTransform } from "@angular/core";
import { FetchOrderNumberDocument } from "../generated-graphql/graphql";

@Pipe({
  name: "orderNumber",
  standalone: true,
})
export default class OrderNumberPipe implements PipeTransform {
  constructor(private dataService: DataService) {}

  transform(orderId: string): Observable<string> {
    return this.dataService
      .query(FetchOrderNumberDocument, {
        orderId: orderId,
      })
      .mapStream((data) => data.order?.code ?? "");
  }
}
